<template>
  <div>
    <h3>Metric definition</h3>

    <p>
      Differently from the other metrics, the collect time metric is based on a
      random variable (the message date), which is modelled by a uniform
      distribution. For a given mesh point, the revisit timeline is separated in
      <katex-element expression="N" /> partitions, where
      <katex-element expression="N" /> corresponds to the number of accesses. A
      partition <katex-element expression="i" /> is defined by a partition start
      date <katex-element expression="t_{0,i}" />, a visibility start date
      <katex-element expression="t_{v,i}" /> and partition end date
      <katex-element expression="t_{f,i}" />, as shown in the Figure below for
      <katex-element expression="N=3" />.
    </p>

    <v-img
      contain
      :src="
        require('../../../assets/images/tooltip-constellation-revisit-partitions.png')
      "
      aspect-ratio="1.6"
    />

    <p>
      <katex-element expression="t_{0,i}" /> is defined as the start of the
      simulation, in the first partition, and as the end of the previous
      partition, for the remaining ones, so that
      <katex-element expression="t_{0,i} = t_{f,i-1}" />. For all partitions,
      <katex-element expression="t_{v,i}" /> is defined as the start of the
      <katex-element expression="i_\mathrm{th}" /> visibility interval, and
      <katex-element expression="t_{f,i}" /> is given by:
    </p>

    <p>
      <katex-element
        expression="t_{f,i} = t_\mathrm{vis,end} - \Delta t_\mathrm{min,point}"
      />
    </p>

    <p>
      where
      <katex-element expression="t_\mathrm{vis,end}" /> is the end of the
      <katex-element expression="i_\mathrm{th}" /> visibility interval and
      <katex-element expression="\Delta t_\mathrm{min,point}" /> is the minimum
      point visibility duration.
    </p>

    <p>
      For a mission with
      <katex-element expression="N" /> revisits, let
      <katex-element expression="t_m" /> be the message date, so that
      <katex-element expression="t_m \sim U(t_{0,i},t_{f,i})" />. The collect
      time <katex-element expression="CT" /> is defined as:
    </p>

    <p>
      <katex-element
        expression="CT = \left\{\begin{array}{cl}
                t_{v,i} - t_m +\Delta t_\mathrm{min,point}&, \text{if $t_{0,i}<t_m<t_{v,i}$} \\
                \Delta t_\mathrm{min,point} &, \text{otherwise}
            \end{array} \right."
      />
    </p>

    <p>for <katex-element expression="i={1,2,...,N}" />.</p>
  </div>
</template>

<script>
export default {
  name: 'tooltipCollectTime'
}
</script>
